const infoCollector = {
  namespaced: true, // 开启命名空间

  state: {
    isAddBtn: false, // 是否展示 loading 加速按钮
    addBtnDisabled: false, // 加速按钮 禁止状态
    addBtnInnerText: '', // 加速按钮 倒计时文案

    activatedFrom: '',

    examples: [], // 步骤二 编辑案例的请求体（用户选中的 符合状态的 范例）

    step1Result: null, // 第一步 点击生成后，接口返回的响应(旧)
    step1GetExaRes: null, // 第一步 点击生成后，接口返回的响应(新)
    step2Result: null, // 点击生成AI后，接口返回的响应
    // loading 状态
    loadingObj: {
      show: false,
      loadingText: '加载中...',
      percentage: 0,
      max: 100
    },
    stepsIndex: 0, // 步骤条当前进度
    timer: null,
    autoIntervalId: null,
    examplesIds: [], // 已选择的样例ID
    updateComponent: false // 当前缓存的组件是否更新数据，比如：步骤一点击 开始采集 进入 步骤二，需要更新步骤二组件；如果步骤一点击的是下一步，步骤二组件不需要更新
  },

  mutations: {
    resetInfoState (state) {
      state.isAddBtn = false
      state.addBtnDisabled = false
      state.addBtnInnerText = ''
      state.activatedFrom = ''
      state.examples = []

      state.step1Result = null
      state.step2Result = null
      state.stepsIndex = 0
      state.timer = null
      state.updateComponent = false
    },
    setStep1Result  (state, payload) {
      state.step1Result = payload
    },
    setStep1GetExaRes  (state, payload) {
      state.step1GetExaRes = payload
    },
    setStep2Result  (state, payload) {
      state.step2Result = payload
    },
    setLoadingObj (state, payload) {
      state.loadingObj = payload
    },
    setStepsIndex (state, payload) {
      state.stepsIndex = payload
    },
    setIsAddBtn (state, payload) {
      state.isAddBtn = payload
    },
    setExamples (state, payload) {
      state.examples = payload
    },
    setActivatedFrom (state, payload) {
      state.activatedFrom = payload
    },

    // 更新加速按钮状态
    setAddBtnInnerText (state, payload) {
      state.addBtnInnerText = payload
    },

    // 进度条控制
    setPercentage (state, { loadingText }) {
      state.loadingObj.show = true
      state.loadingObj.percentage = 0
      state.loadingObj.loadingText = loadingText
      state.timer = setInterval(() => {
        let _percentage = state.loadingObj.percentage
        if (state.loadingObj.percentage < 50) {
          _percentage = state.loadingObj.percentage + 3
        } else if (state.loadingObj.percentage < 80) {
          _percentage = state.loadingObj.percentage + 2
        } else if (state.loadingObj.percentage < 98) {
          _percentage = state.loadingObj.percentage + 1
        }
        state.loadingObj.percentage = _percentage
      }, 1500)
    },

    // 自定义传入进度条最大值
    setPercentageMaxLimit (state, { loadingText, max, ms, addPercentage }) {
      state.loadingObj.show = true
      state.loadingObj.loadingText = loadingText
      state.timer = setInterval(() => {
        // let _percentage = state.loadingObj.percentage
        if (state.loadingObj.percentage < max) {
          state.loadingObj.percentage = state.loadingObj.percentage + addPercentage
        }
        // state.loadingObj.percentage = _percentage
      }, ms)
    },

    // 设置进度条初始值
    setPercentageNum (state, payload) {
      state.loadingObj.percentage = payload
    },

    // 展示进度条弹窗
    showLoading (state) {
      state.loadingObj.show = true
    },

    // 清除进度条定时器
    clearTimer (state) {
      clearInterval(state.timer) // 清除定时器
    },

    // 进度条终点
    setPercentageEnd (state, max) {
      state.loadingObj.max = max
    },

    // 开启 进度条定时器
    startPercentageSetInterval (state, addPercentage) {
      const max = state.loadingObj.max
      state.timer = setInterval(() => {
        // 当前值小于结束值，更新当前值
        if (state.loadingObj.percentage < max) {
          state.loadingObj.percentage = state.loadingObj.percentage + addPercentage
        }
      }, 1000)
    },

    // 清空自动加速定时器
    clearIntervalByAuto (state) {
      state.autoIntervalId = null
      clearInterval(state.autoIntervalId)
    },

    // 关闭进度条
    closePercentage (state) {
      clearInterval(state.timer)
      state.loadingObj.show = false
      state.loadingObj.percentage = 100
    },

    // 是否更新当前缓存组件的数据
    setUpdateComponent (state, payload) {
      state.updateComponent = payload
    },

    // 更新样例ID
    setExamplesIds (state, payload) {
      state.examplesIds = payload
    }
  },

  actions: {
    countdown ({ state, commit }, seconds = 3) {
      return new Promise((resolve, reject) => {
        let remainingSeconds = seconds
        commit('setAddBtnInnerText', `${remainingSeconds} 秒后自动加速`)

        state.autoIntervalId = setInterval(() => {
          remainingSeconds--

          if (remainingSeconds <= 0) {
            commit('setAddBtnInnerText', '') // 清空按钮文案
            commit('clearIntervalByAuto') // 清空自动加速定时器
            resolve('stop') // 返回输出结果
          } else {
            // 更新自动加速按钮的倒计时文案
            commit('setAddBtnInnerText', `${remainingSeconds} 秒后自动加速`)
          }
        }, 1000)
      })
    }
  }
}

export default infoCollector



// WEBPACK FOOTER //
// ./src/store/infoCollector.js